import React from 'react';
import './order-details.scss';
import { Text } from '../../common';
import { SVGS } from '../../assets';
import { getFormattedAmount } from '@zonofi/common/functions/format-amount';

interface LineDiscountCardProps {
  discount: number;
  linePrice: number;
  discountedLinePrice: number;
  isPercent: boolean;
  onRemove?: () => void;
}

export const LineDiscountCard: React.FC<LineDiscountCardProps> = ({
  discount,
  linePrice,
  discountedLinePrice,
  isPercent,
  onRemove,
}) => {
  const discountAmount = linePrice - discountedLinePrice;

  return (
    <span className="order-details-discount">
      <img src={SVGS.DiscountIcon} />
      <span className="order-details-discount-v1-text font-medium">
        {isPercent
          ? `${discount}% Offer Applied`
          : `${getFormattedAmount(Number(discount))} Offer Applied`}
        {isPercent && (
          <Text className="order-details-discount-v2-text font-medium">{` worth ${getFormattedAmount(
            discountAmount
          )}`}</Text>
        )}
      </span>
      {onRemove && (
        <span className="order-details-discount-remove-view" onClick={onRemove}>
          <Text className="order-details-discount-remove-text font-medium">
            {'Remove'}
          </Text>
        </span>
      )}
    </span>
  );
};
